/*
 * Назначение: страница 404.
 * Функционал: понятное объяснение и кнопка возврата на дашборд.
 */

import { Compass } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../components/ui/button";

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center space-y-4">
        <div className="mx-auto h-12 w-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
          <Compass className="h-6 w-6" />
        </div>
        <h1 className="text-3xl font-semibold">Страница не найдена</h1>
        <p className="text-muted-foreground">
          Похоже, такого адреса в админке нет. Проверь ссылку или вернись к дашборду.
        </p>
        <Button asChild>
          <Link to="/dashboard">Перейти на дашборд</Link>
        </Button>
      </div>
    </div>
  );
}
